<template>
  <div>
    <!-- 授权协议对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :title="$t('examineAKSK.authDialogTitle')"
      :visible.sync="empowerDialogVisible"
      center
      width="997px"
      @close="empowerDialogVisible = false"
    >
      <!-- 授权协议内容区域 -->
      <div>
        <!-- 授权描述内容（国际化处理） -->
        <p>{{ $t('examineAKSK.authDescription1') }}</p>
        <p>{{ $t('examineAKSK.authDescription2') }}</p>
        <p>{{ $t('examineAKSK.authDescription3') }}</p>
        <p>{{ $t('examineAKSK.authDescription4') }}</p>
        <p>{{ $t('examineAKSK.authDescription5') }}</p>
        <!-- 授权警告内容（国际化处理） -->
        <p>
          {{ $t('examineAKSK.authWarning1') }}
          <b>{{ $t('examineAKSK.authWarning2') }}</b>
          {{ $t('examineAKSK.authWarning3') }}
        </p>
      </div>

      <!-- 对话框底部按钮区域 -->
      <template #footer>
        <!-- 取消按钮（国际化处理） -->
        <el-button style="width: 80px;" @click="examineAKSKVisibleFalse()">
          {{ $t('examineAKSK.cancel') }}
        </el-button>
        <!-- 同意按钮（国际化处理） -->
        <el-button style="width: 80px;" type="primary" @click="createTeamInfo">
          {{ $t('examineAKSK.agree') }}
        </el-button>
      </template>
    </el-dialog>

    <!-- AK/SK录入对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :title="$t('examineAKSK.inputDialogTitle')"
      :visible.sync="examineAKSKDialogVisible"
      width="997px"
      @close="resetFormInfo"
    >
      <div>
        <!-- AK/SK表单区域 -->
        <el-form
          ref="secondRuleForm"
          :model="secondStepRuleForm"
          :rules="secondStepRules"
          label-position="left"
          label-width="100px"
        >
          <!-- SecretID输入项 -->
          <el-form-item :label="$t('examineAKSK.secretID')" prop="secretID">
            <el-input
              v-model="secondStepRuleForm.secretID"
              :placeholder="$t('examineAKSK.inputPlaceholder')"
            ></el-input>
          </el-form-item>

          <!-- SecretKey输入项 -->
          <el-form-item :label="$t('examineAKSK.secretKey')" prop="secretKey">
            <el-input
              v-model="secondStepRuleForm.secretKey"
              :placeholder="$t('examineAKSK.inputPlaceholder')"
              type="password"
            ></el-input>
          </el-form-item>
        </el-form>

        <!-- 帮助信息区域 -->
        <div class="base-margin__top-5">
          <!-- 腾讯云跳转提示（国际化处理） -->
          <p>
            {{ $t('examineAKSK.tencentCloudTip1') }}
            <span
              class="base-color__light_blue base-cursor__pointer"
              @click="goTencentCloud"
            >
          {{ $t('examineAKSK.tencentCloudTip2') }}
          </span>
          </p>

          <!-- 子账号策略语法区域 -->
          <div class="base-margin__top-10">
            <h3>{{ $t('examineAKSK.subAccountPolicy') }}</h3>  <!-- 国际化标题 -->
            <div class="grammar">
              <span>{{ grammar }}</span>  <!-- 显示策略语法内容 -->
              <!-- 复制按钮 -->
              <i class="el-icon-copy-document copy-icon" @click="copy(grammar)"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 对话框底部按钮区域 -->
      <template #footer>
        <!-- 校验并保存按钮（国际化处理） -->
        <el-button
          :loading="saveAKSKButtonLoading"
          type="primary"
          @click="examineAndSaveAksk"
        >
          {{ $t('examineAKSK.verifyAndSave') }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {Message} from 'element-ui';
import {getRequest, postRequest} from '@/common/libs/request';
import {UTIL} from '@/common/utils';
import {TENCENT_CLOUD_CREATE_USER_URL} from '@/common/constants';

export default {
  name: 'examineAkSK',  // 组件名称

  /**
   * 组件属性定义
   * @property {Boolean} examineAKSKVisible - 控制授权对话框显示/隐藏
   * @property {Function} examineAKSKVisibleFalse - 关闭授权对话框的方法
   */
  props: {
    examineAKSKVisible: {
      type: Boolean,
      default: false,
    },
    examineAKSKVisibleFalse: {
      type: Function,
    },
  },

  /**
   * 监听器定义
   * 监听examineAKSKVisible属性变化，更新对话框显示状态
   */
  watch: {
    examineAKSKVisible: {
      deep: true,  // 深度监听
      handler(newVal) {
        this.empowerDialogVisible = newVal;
      },
    },
  },

  /**
   * 组件数据定义
   * @returns {Object} 组件数据对象
   */
  data() {
    return {
      empowerDialogVisible: false,  // 授权对话框显示状态

      // 表单验证规则
      secondStepRules: {
        secretID: [{
          required: true,
          message: this.$t('examineAKSK.inputRequired'),  // 国际化错误提示
          trigger: 'blur'
        }],
        secretKey: [{
          required: true,
          message: this.$t('examineAKSK.inputRequired'),  // 国际化错误提示
          trigger: 'blur'
        }],
      },

      saveAKSKButtonLoading: false,  // 保存按钮加载状态
      examineAKSKDialogVisible: false,  // AK/SK对话框显示状态
      grammar: '',  // 策略语法内容

      // 表单数据
      secondStepRuleForm: {
        secretID: '',  // SecretID
        secretKey: '',  // SecretKey
      },

      projectId: 0,  // 项目ID
    };
  },

  /**
   * 组件挂载后钩子
   * 初始化获取策略语法
   */
  mounted() {
    this.getGrammar();
  },

  /**
   * 组件方法定义
   */
  methods: {
    /**
     * 创建团队信息
     * 1. 关闭授权协议对话框
     * 2. 打开AK/SK录入对话框
     * 调用方式：点击授权协议对话框的"同意"按钮时触发
     */
    createTeamInfo() {
      this.examineAKSKVisibleFalse();
      this.examineAKSKDialogVisible = true;
    },

    /**
     * 校验并保存AK/SK
     * 1. 验证表单数据有效性
     * 2. 显示校验中提示信息
     * 3. 发送请求校验AK/SK权限
     * 4. 根据校验结果决定是否保存
     * 调用方式：点击AK/SK录入对话框的"校验并保存"按钮时触发
     */
    examineAndSaveAksk() {
      this.$refs.secondRuleForm.validate((valid) => {
        if (valid) {
          // 显示校验中提示（国际化处理）
          Message.success(this.$t('examineAKSK.verifying'));
          this.saveAKSKButtonLoading = true;

          // 发送校验请求
          postRequest('/api/eda/common/eda/checkProjectTencentAccount', {
            secretId: UTIL.rsaEncryption(this.secondStepRuleForm.secretID),
            secretKey: UTIL.rsaEncryption(this.secondStepRuleForm.secretKey),
          }).then(async (res) => {
            if (!res.allow) {
              // 权限不足提示（国际化处理）
              this.$message.error(this.$t('examineAKSK.insufficientPermission'));
              this.saveAKSKButtonLoading = false;
            } else {
              // 校验通过后保存
              this.saveProjectTencentAccount();
            }
          })
            .catch(() => {
              this.saveAKSKButtonLoading = false;
            });
        }
      });
    },

    /**
     * 保存AK/SK到项目
     * 1. 从sessionStorage获取当前项目ID
     * 2. 显示保存中提示信息
     * 3. 发送加密后的AK/SK到后端保存
     * 4. 处理保存成功/失败逻辑
     * 调用方式：在AK/SK校验通过后自动调用
     */
    saveProjectTencentAccount() {
      const projectId = JSON.parse(sessionStorage.getItem('currentProject')).id;
      this.$refs.secondRuleForm.validate((valid) => {
        if (valid) {
          // 显示保存中提示（国际化处理）
          Message.success(this.$t('examineAKSK.saving'));

          // 发送保存请求
          postRequest('/api/eda/common/eda/saveProjectTencentAccount', {
            secretId: UTIL.rsaEncryption(this.secondStepRuleForm.secretID),
            secretKey: UTIL.rsaEncryption(this.secondStepRuleForm.secretKey),
            projectId,
          }).then(() => {
            // 保存成功提示（国际化处理）
            Message.success(this.$t('examineAKSK.saveSuccess'));
            this.saveAKSKButtonLoading = false;
            this.examineAKSKDialogVisible = false;
          })
            .catch(() => {
              this.saveAKSKButtonLoading = false;
            });
        }
      });
    },

    /**
     * 重置表单信息
     * 1. 清空SecretID和SecretKey输入框
     * 2. 重置表单验证状态
     * 调用方式：AK/SK录入对话框关闭时触发
     */
    resetFormInfo() {
      this.$refs.secondRuleForm.resetFields();
    },

    /**
     * 跳转到腾讯云创建用户页面
     * 1. 在新标签页打开腾讯云子账号创建页面
     * 调用方式：点击"点击跳转"链接时触发
     */
    goTencentCloud() {
      window.open(TENCENT_CLOUD_CREATE_USER_URL, '_blank');
    },

    /**
     * 复制文本到剪贴板
     * @param {string} val - 需要复制的文本内容
     * 1. 调用UTIL.copyText方法实现复制功能
     * 2. 显示复制成功提示
     * 调用方式：点击策略语法区域的复制图标时触发
     */
    copy(val) {
      UTIL.copyText(this, val);
    },

    /**
     * 获取策略语法
     * 1. 从API获取子账号策略语法配置
     * 2. 将获取的策略语法赋值给grammar变量
     * 调用方式：组件挂载完成后自动调用
     */
    getGrammar() {
      getRequest('/api/common/getSetting?key=policy').then((res) => {
        this.grammar = res;
      });
    },
  },
};
</script>

<style lang="scss">
/* 策略语法样式 */
.grammar {
  border-radius: 3px;
  opacity: 1;
  border: 1px solid rgba(220, 220, 220, 1);
  padding: 8px;
  position: relative;
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
  font-weight: 400;
  margin-top: 8px;

  /* 复制按钮样式 */
  .copy-icon {
    position: absolute;
    right: 8px;
    bottom: 8px;
    cursor: pointer;
  }
}
</style>
